// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__ktlp-","approved":"Status_approved__1bcAI","rejected":"Status_rejected__1hTNh","expired":"Status_expired__3Hph3","label":"Status_label__5Am03"};